import React, { useState, useEffect, useRef } from 'react';

const MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
];
const CURRENT_YEAR = new Date().getFullYear();
const YEARS = Array.from({ length: 80 }, (_, i) => CURRENT_YEAR - i);

function daysInMonth(month, year) {
    if (!month) return 31;
    return new Date(year || 2000, month, 0).getDate();
}

function DobPicker({ value, onChange, placeholder, options, width }) {
    return (
        <div className="dob-picker" style={{ width }}>
            <select
                value={value}
                onChange={e => onChange(e.target.value)}
                className={'dob-select' + (value ? ' is-filled' : '')}
            >
                <option value="">{placeholder}</option>
                {options.map(o => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                ))}
            </select>
            <span className="dob-chev">▾</span>
        </div>
    );
}

export default function TBRLoginGate({ onLogin, error }) {
    const [name, setName] = useState('');
    const [day, setDay] = useState('');
    const [month, setMonth] = useState('');
    const [year, setYear] = useState('');
    const [localErr, setLocalErr] = useState('');
    const nameRef = useRef(null);

    useEffect(() => { nameRef.current?.focus(); }, []);

    useEffect(() => {
        if (!day || !month) return;
        const max = daysInMonth(Number(month), Number(year));
        if (Number(day) > max) setDay(String(max));
    }, [day, month, year]);

    const displayError = error || localErr;

    function submit(e) {
        e.preventDefault();
        const trimmed = name.trim();
        if (!trimmed) {
            setLocalErr('Tell us your first name.');
            nameRef.current?.focus();
            return;
        }
        if (!day || !month || !year) {
            setLocalErr('Please choose your full date of birth.');
            return;
        }
        setLocalErr('');
        const dob = `${String(day).padStart(2, '0')}-${String(month).padStart(2, '0')}-${year}`;
        onLogin(trimmed, dob);
    }

    const maxDay = daysInMonth(Number(month), Number(year));

    return (
        <div className="gate-wrap">
            <div className="gate-stack">
                <div className="gate-eyebrow">
                    <span className="gate-eyebrow-rule" />
                    <span>Private · Family only</span>
                    <span className="gate-eyebrow-rule" />
                </div>
                <h1 className="gate-bigtitle">
                    The J-Girls<br />&amp; Ma <em>TBR Index</em>
                </h1>
                <p className="gate-lede">
                    A quiet corner for sharing what we each want to read next —
                    so birthdays and Christmas can stay a surprise.
                </p>

                <form className="gate-card-v2" onSubmit={submit}>
                    <div className="gate-card-corners">
                        <span /><span /><span /><span />
                    </div>
                    <div className="gate-card-stamp-row">
                        <span className="gate-card-no">No. 5 · Vol. I · 2026</span>
                        <span className="gate-card-stamp">Sign in</span>
                    </div>

                    <label className="gate-field-v2">
                        <span className="gate-label">First name</span>
                        <input
                            ref={nameRef}
                            className="gate-input-big"
                            type="text"
                            autoComplete="off"
                            value={name}
                            onChange={e => { setName(e.target.value); if (localErr) setLocalErr(''); }}
                        />
                    </label>

                    <div className="gate-field-v2">
                        <span className="gate-label">Date of birth</span>
                        <div className="dob-row">
                            <DobPicker
                                value={day}
                                onChange={setDay}
                                placeholder="Day"
                                options={Array.from({ length: maxDay }, (_, i) => ({ value: String(i + 1), label: String(i + 1) }))}
                                width={92}
                            />
                            <DobPicker
                                value={month}
                                onChange={setMonth}
                                placeholder="Month"
                                options={MONTHS.map((m, i) => ({ value: String(i + 1), label: m }))}
                                width={150}
                            />
                            <DobPicker
                                value={year}
                                onChange={setYear}
                                placeholder="Year"
                                options={YEARS.map(y => ({ value: String(y), label: String(y) }))}
                                width={110}
                            />
                        </div>
                    </div>

                    <button className="gate-submit-v2" type="submit">
                        <span>Sign in</span>
                        <span className="gate-submit-arrow">→</span>
                    </button>
                    {displayError && <div className="gate-error">{displayError}</div>}
                </form>
            </div>
        </div>
    );
}
